import styled from 'styled-components';
import { Paper } from '@mui/material';

export const Container = styled.div`
  padding: 32px;
`;

export const FormWrapper = styled(Paper)`
  padding: 24px;
  margin-top: 16px;
  max-width: 600px;
`;
